// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NVCww","header__wrapper":"style_header__wrapper__paxCi","header-logo":"style_header-logo__fp_ax","header__code":"style_header__code__NnmWH"};